export class NmibleCountries {
    public static all() {
        return [
            { "name": "United Kingdom", "code": "GB", "currency": "GBP" },
            { "name": "United States", "code": "US", "currency": "USD" },
            { "name": "Argentina", "code": "AR", "currency": "ARS" },
            { "name": "Australia", "code": "AU", "currency": "AUD" },
            { "name": "Belgium", "code": "BE", "currency": "EUR" },
            { "name": "Brazil", "code": "BR", "currency": "BRL" },
            { "name": "Bulgaria", "code": "BG", "currency": "BGN" },
            { "name": "Canada", "code": "CA", "currency": "CAD" },
            { "name": "China", "code": "CN", "currency": "CNY" },
            { "name": "Colombia", "code": "CO", "currency": "COP" },
            { "name": "Czech Republic", "code": "CZ", "currency": "CZK" },
            { "name": "Denmark", "code": "DK", "currency": "DKK" },
            { "name": "Dominican Republic", "code": "DO", "currency": "DOP" },
            { "name": "Estonia", "code": "EE", "currency": "EUR" },
            { "name": "Finland", "code": "FI", "currency": "EUR" },
            { "name": "France", "code": "FR", "currency": "EUR" },
            { "name": "Germany", "code": "DE", "currency": "EUR" },
            { "name": "Greece", "code": "GR", "currency": "EUR" },
            { "name": "Hong Kong", "code": "HK", "currency": "HKD" },
            { "name": "Hungary", "code": "HU", "currency": "HUF" },
            { "name": "Israel", "code": "IL", "currency": "ILS" },
            { "name": "Italy", "code": "IT", "currency": "EUR" },
            { "name": "Japan", "code": "JP", "currency": "JPY" },
            { "name": "Korea, Republic of", "code": "KR", "currency": "KRW" },
            { "name": "Latvia", "code": "LV", "currency": "EUR" },
            { "name": "Lithuania", "code": "LT", "currency": "EUR" },
            { "name": "Mexico", "code": "MX", "currency": "MXN" },
            { "name": "Netherlands", "code": "NL", "currency": "EUR" },
            { "name": "New Zealand", "code": "NZ", "currency": "NZD" },
            { "name": "Norway", "code": "NO", "currency": "NOK" },
            { "name": "Poland", "code": "PL", "currency": "PLN" },
            { "name": "Romania", "code": "RO", "currency": "RON" },
            { "name": "Serbia", "code": "RS", "currency": "RSD" },
            { "name": "Slovakia", "code": "SK", "currency": "EUR" },
            { "name": "South Africa", "code": "ZA", "currency": "ZAR" },
            { "name": "Spain", "code": "ES", "currency": "EUR" },
            { "name": "Thailand", "code": "TH", "currency": "THB" },
            { "name": "Turkey", "code": "TR", "currency": "TRY" },
            { "name": "United Arab Emirates", "code": "AE", "currency": "AED" }
        ];
    }
}